import styles from "./badges.module.scss"

type Props = {
	isPayout: boolean
}

const PaymentTypeBadge = ({ isPayout }: Props) => {
	return (
		<span
			className={`${styles.badge} ${isPayout ? styles.payout : styles.invoice}`}
		>
			{isPayout ? "SOUHL 振込" : "御社 支払い"}
		</span>
	)
}

export default PaymentTypeBadge
